import React, { useState } from "react";
import TimesheetsTable from "@/components/TimesheetsTable";
import { startOfToday, endOfToday } from "date-fns";

export default function TimesheetsIndex() {
    const [selectedRange, setSelectedRange] = useState("today");

    const getDateRange = (range) => {
        const today = new Date();
        const dayOfWeek = today.getDay();

        switch (range) {
            case "today":
                return {
                    start_date: startOfToday().toISOString(),
                    end_date: endOfToday().toISOString(),
                };
            case "yesterday": {
                const yesterday = new Date();
                yesterday.setDate(today.getDate() - 1);
                return {
                    start_date: new Date(yesterday.setHours(0, 0, 0, 0)).toISOString(),
                    end_date: new Date(yesterday.setHours(23, 59, 59, 999)).toISOString(),
                };
            }
            case "this_week": {
                const start = new Date(today);
                start.setDate(today.getDate() - dayOfWeek);
                const end = new Date(start);
                end.setDate(start.getDate() + 6);
                return {
                    start_date: new Date(start.setHours(0, 0, 0, 0)).toISOString(),
                    end_date: new Date(end.setHours(23, 59, 59, 999)).toISOString(),
                };
            }
            case "last_week": {
                const start = new Date(today);
                start.setDate(today.getDate() - dayOfWeek - 7);
                const end = new Date(start);
                end.setDate(start.getDate() + 6);
                return {
                    start_date: new Date(start.setHours(0, 0, 0, 0)).toISOString(),
                    end_date: new Date(end.setHours(23, 59, 59, 999)).toISOString(),
                };
            }
            case "this_month": {
                const start = new Date(today.getFullYear(), today.getMonth(), 1);
                const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                return {
                    start_date: new Date(start.setHours(0, 0, 0, 0)).toISOString(),
                    end_date: new Date(end.setHours(23, 59, 59, 999)).toISOString(),
                };
            }
            default:
                return {};
        }
    };

    const filters = getDateRange(selectedRange);

    return (
        <div className="p-6 max-w-6xl mx-auto">
            <h1 className="text-2xl font-bold text-[#5D1F42] mb-4">Time Sheets</h1>
            <div className="mb-4 space-x-2">
                {["today", "yesterday", "this_week", "last_week", "this_month", "all"].map((label) => (
                    <button
                        key={label}
                        onClick={() => setSelectedRange(label)}
                        className={`px-4 py-2 text-sm rounded-lg border transition ${
                            selectedRange === label
                                ? "bg-[#5D1F42] text-white border-[#5D1F42]"
                                : "bg-white text-gray-800 border-gray-300 hover:bg-gray-100"
                        }`}
                    >
                        {label.replace("_", " ").replace(/\b\w/g, (l) => l.toUpperCase())}
                    </button>
                ))}
            </div>
            <TimesheetsTable filters={filters} additionalColumns={['venue', 'job', 'candidate']} />
        </div>
    );
}
